import { type ComputedRef, ref } from 'vue';

export function useBeforeLeave(dirty?: ComputedRef<boolean>) {
  const dialogOpener = ref<boolean>(false);
  const dialogPopupRef = ref(false);
  const dialogLeaveValue = ref(false);

  const dialogLeave = (emitValue: boolean) => {
    dialogPopupRef.value = false;
    dialogLeaveValue.value = emitValue;
    if (emitValue) {
      dialogOpener.value = false;
      dialogLeaveValue.value = false;
    }
  };

  const dialogClose = () => {
    if (dialogLeaveValue.value === false && dirty?.value) {
      dialogPopupRef.value = true;
    } else {
      dialogOpener.value = false;
    }
  };

  return {
    dialogPopupRef,
    dialogLeave,
    dialogOpener,
    dialogClose
  };
}
